import HeroBackground from './HeroBackground';
import { NAV_ITEMS, scrollToId } from '../lib/scroll';
import logo from '../assets/img/logo.svg';

export default function Hero() {
  return (
    <section aria-label="Hero" className="relative h-screen overflow-hidden bg-ink-900">
      <HeroBackground />

      <div className="relative z-10 mx-auto flex h-full max-w-[1370px] flex-col justify-between px-4 pt-6 pb-20 lg:pt-11">
        <div className="flex justify-center">
          <img
            src={logo}
            alt="Gravity Technologies"
            className="h-12 w-auto drop-shadow-[0_2px_24px_rgba(0,0,0,0.7)] sm:h-14 md:h-16 lg:h-20"
          />
        </div>

        <div>
          <p className="mb-12 max-w-2xl font-gotham font-light text-2xl leading-snug tracking-tight text-white [text-shadow:0_2px_24px_rgba(0,0,0,0.85)] md:text-3xl lg:text-4xl">
            Software that bends to your needs.{' '}
            <span className="text-brand-yellow">35 years</span> of engineering gravity.
          </p>
          <nav
            aria-label="Page sections"
            className="flex flex-col space-y-8 font-gotham text-lg text-white [text-shadow:0_2px_16px_rgba(0,0,0,0.85)] md:text-xl lg:text-2xl"
          >
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToId(item.id)}
                className="w-max py-1 text-left motion-safe:transition motion-safe:duration-500 motion-safe:ease-in-out motion-safe:hover:translate-x-8 hover:text-brand-yellow"
              >
                {item.label}
              </button>
            ))}
          </nav>
        </div>

        <button
          onClick={() => scrollToId('facts')}
          aria-label="Scroll down to content"
          className="mx-auto text-xs tracking-[0.3em] text-text-dim transition-colors hover:text-brand-yellow"
        >
          SCROLL ↓
        </button>
      </div>
    </section>
  );
}
